export default __webpack_public_path__ + "locales/si/JavascriptSdk.json?hash=de5f14dea2bd49b48089e2dc1657cf07";